import {persianCopy} from './persianTranslations.js';
export const savedRecordsCopy = {
  "tr": [
    "Bu tarayıcıda seçtiğiniz içerikler.",
    "Kayıtlarında ara",
    "Henüz kaydedilmiş içerik yok.",
    "İlahilerde yer imi düğmesine basarak listenizi oluşturabilirsiniz.",
    "İlahileri keşfet",
    "Aramanızla eşleşen kayıt yok.",
    "Seçimler bu tarayıcıda saklanır; hesabınızla diğer cihazlara eşitlenmez.",
    "Kaydı aç"
  ],
  "en": [
    "Content selected in this browser.",
    "Search your saved items",
    "No saved content yet.",
    "Use the bookmark button on hymns to create your list.",
    "Explore hymns",
    "No saved items match your search.",
    "Selections are stored in this browser and do not sync to your account on other devices.",
    "Open item"
  ],
  "de": [
    "In diesem Browser ausgewählte Inhalte.",
    "Gespeicherte Inhalte durchsuchen",
    "Noch keine gespeicherten Inhalte.",
    "Erstellen Sie Ihre Liste mit den Lesezeichen bei den Hymnen.",
    "Hymnen entdecken",
    "Keine passenden Einträge gefunden.",
    "Die Auswahl wird in diesem Browser gespeichert und nicht über Ihr Konto mit anderen Geräten synchronisiert.",
    "Eintrag öffnen"
  ],
  "ar": [
    "المحتوى الذي اخترته في هذا المتصفح.",
    "ابحث في المحفوظات",
    "لا يوجد محتوى محفوظ بعد.",
    "استخدم زر الإشارة المرجعية في الأناشيد لإنشاء قائمتك.",
    "استكشف الأناشيد",
    "لا توجد نتائج مطابقة لبحثك.",
    "تُحفظ الاختيارات في هذا المتصفح ولا تتزامن مع حسابك على الأجهزة الأخرى.",
    "افتح المحتوى"
  ],
  "fr": [
    "Contenus sélectionnés dans ce navigateur.",
    "Rechercher dans vos favoris",
    "Aucun contenu enregistré.",
    "Utilisez le marque-page des chants pour créer votre liste.",
    "Découvrir les chants",
    "Aucun contenu ne correspond à votre recherche.",
    "Les sélections sont stockées dans ce navigateur, sans synchronisation avec votre compte sur les autres appareils.",
    "Ouvrir"
  ],
  "es": [
    "Contenido seleccionado en este navegador.",
    "Buscar en tus guardados",
    "Todavía no hay contenido guardado.",
    "Usa el marcador de los himnos para crear tu lista.",
    "Explorar himnos",
    "No hay resultados para tu búsqueda.",
    "Las selecciones se guardan en este navegador y no se sincronizan con tu cuenta en otros dispositivos.",
    "Abrir"
  ],
  "ru": [
    "Материалы, выбранные в этом браузере.",
    "Поиск в сохранённом",
    "Сохранённых материалов пока нет.",
    "Добавляйте песнопения в закладки, чтобы составить список.",
    "Открыть песнопения",
    "Совпадений не найдено.",
    "Выбор хранится в этом браузере и не синхронизируется с аккаунтом на других устройствах.",
    "Открыть"
  ],
  "zh": [
    "在此浏览器中收藏的内容。",
    "搜索收藏",
    "暂无收藏内容。",
    "点击颂歌的书签按钮即可创建收藏列表。",
    "浏览颂歌",
    "没有匹配的收藏。",
    "收藏保存在此浏览器中，不会通过账户同步到其他设备。",
    "打开"
  ]
};

savedRecordsCopy.fa=persianCopy(savedRecordsCopy.tr);

const accountCopy={"tr": ["Hesabınıza kaydettiğiniz içerikler.", "Seçimler hesabınızda saklanır ve diğer cihazlarda aynı hesapla görünür.", "Kayıtlarınız yükleniyor…", "Kayıtlar alınamadı. Sayfayı yeniden yükleyin.", "Seçim kaydedilemedi. Sayfayı yeniden yükleyin."], "en": ["Content saved to your account.", "Selections are saved to your account and available on other devices when signed in.", "Loading saved items…", "Could not load saved items. Reload the page.", "Could not save selection. Reload the page."], "de": ["In Ihrem Konto gespeicherte Inhalte.", "Die Auswahl wird im Konto gespeichert und ist auf anderen Geräten nach der Anmeldung verfügbar.", "Gespeicherte Inhalte werden geladen…", "Inhalte konnten nicht geladen werden. Seite neu laden.", "Auswahl konnte nicht gespeichert werden. Seite neu laden."], "ar": ["المحتوى المحفوظ في حسابك.", "تُحفظ اختياراتك في حسابك وتظهر على الأجهزة الأخرى عند تسجيل الدخول.", "جارٍ تحميل المحفوظات…", "تعذر تحميل المحفوظات. أعد تحميل الصفحة.", "تعذر حفظ الاختيار. أعد تحميل الصفحة."], "fr": ["Contenus enregistrés dans votre compte.", "Vos choix sont enregistrés dans votre compte et disponibles sur vos autres appareils après connexion.", "Chargement des éléments…", "Impossible de charger les éléments. Rechargez la page.", "Impossible de sauvegarder le choix. Rechargez la page."], "es": ["Contenido guardado en tu cuenta.", "Tus selecciones se guardan en tu cuenta y están disponibles en otros dispositivos al iniciar sesión.", "Cargando elementos…", "No se pudieron cargar los elementos. Recarga la página.", "No se pudo guardar la selección. Recarga la página."], "ru": ["Материалы, сохранённые в вашем аккаунте.", "Выбор сохраняется в аккаунте и доступен на других устройствах после входа.", "Загрузка сохранённого…", "Не удалось загрузить. Обновите страницу.", "Не удалось сохранить выбор. Обновите страницу."], "zh": ["保存到您帐户的内容。", "选择保存在您的帐户中，登录后可在其他设备上查看。", "正在加载收藏…", "无法加载收藏。请刷新页面。", "无法保存选择。请刷新页面。"], "fa": ["محتوای ذخیره‌شده در حساب شما.", "انتخاب‌ها در حساب شما ذخیره می‌شوند و با ورود در دستگاه‌های دیگر نمایش داده می‌شوند.", "در حال بارگذاری ذخیره‌ها…", "بارگذاری انجام نشد. صفحه را دوباره بارگذاری کنید.", "ذخیره انجام نشد. صفحه را دوباره بارگذاری کنید."]};
for(const [locale,copy] of Object.entries(accountCopy)){savedRecordsCopy[locale][0]=copy[0];savedRecordsCopy[locale][6]=copy[1];savedRecordsCopy[locale].push(...copy.slice(2));}
